import { AbstractControl, ValidatorFn } from '@angular/forms';
import { getFilesFromControl } from './files-from-control.function';
import { getFileSize } from './get-file-size.function';

export function fileSizeValidator(numberOfMegabytes: number): ValidatorFn {
	return (control: AbstractControl) => {
		const files = getFilesFromControl(control);

		if (!files) {
			return null;
		}

		return files.map(file => getFileSize(file.size || 0)).some(fileSize => fileSize > numberOfMegabytes)
			? { fileSize: true }
			: null;
	};
}
